import { create, type StateCreator } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface UiState {
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (sidebarCollapsed: boolean) => void;
}

const createUiSlice: StateCreator<UiState, [['zustand/immer', never]], [], UiState> = (set) => ({
  sidebarCollapsed: false,
  setSidebarCollapsed: (sidebarCollapsed) => {
    set((s) => {
      s.sidebarCollapsed = sidebarCollapsed;
    });
  },
});

export const useUiStore = create<UiState>()(immer(createUiSlice));
